<script>
import SelectOne from '../__components/SelectOne.vue';
import SelectMultiple from '../__components/SelectMultiple.vue';
import MixinItem from '../__mixins/item';

export default {
  name: 'FormSelect',
  mixins: [MixinItem],
  components: {
    SelectOne,
    SelectMultiple,
  },
  props: {
    value: {},
  },
  computed: {
    com() {
      return this.module.multiple ? 'SelectMultiple' : 'SelectOne';
    },
  },
  mounted() {
  },
};
</script>
<template>
  <div class="f-flex">
    <component
      :is="com"
      class="f-flex__auto"
      :value="value"
      :placeholder="placeholder"
      :disabled="module.disabled"
      :options="module.options"
      :multiple="module.multiple"
      :clearable="module.clearable"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
      @input="$emit('input', $event)"
      @change="$emit('change', $event)"
      @submit="$emit('submit', $event)"
    />
    <div class="f-flex__shink">
      <slot></slot>
    </div>
  </div>
</template>
